import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import classNames from "classnames";
export const ListItemSecondaryAction = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    className,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(MuiListItemSecondaryAction, _extends({}, otherProps, {
    ref: ref,
    className: classNames("prmbl-listItemSecondaryAction", className)
  }));
});
// Excluding the muiName prop from the forwardRef simplifies the types.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
ListItemSecondaryAction.displayName = "ListItemSecondaryAction";
export default ListItemSecondaryAction;